import { useState, useEffect, useRef } from 'react';
import { Select as AntdSelect } from 'antd';
import * as T from '../../Typography';
import * as S from './style';
import * as CS from './../style';

const { OptGroup: AntdOptGroup } = AntdSelect;

const Dropdown = ({
  handleChange,
  label,
  color,
  placeholder = 'Select...',
  error,
  helper,
  w,
  disabled,
  options = [],
  groupedOptions,
  selected,
  multi,
  m,
  bold,
  search,
  addNew,
  allowClear,
  name,
  required,
  customOptions,
  focused,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const [focus, setFocus] = useState(false);

  const selectRef = useRef(null);

  useEffect(() => {
    setFocus(focused);

    if (!focused) {
      selectRef?.current.blur();
    }
  }, [focused]);

  const decideColor = () => {
    if (error) return 'error';

    return color;
  };

  const isSelected = option =>
    selected === option || (selected && selected.toString().includes(option));

  const renderOptions = () => {
    if (groupedOptions) {
      return options.map(({ groupLabel, options: _options }) => (
        <AntdOptGroup
          label={
            <T.P m="0" mt="4" color="primary">
              {groupLabel}
            </T.P>
          }
          key={groupLabel}
        >
          {_options.map(opt => (
            <S.Option
              key={`${groupLabel}_${opt.label}`}
              value={opt.value}
              points={opt.points}
              isSelected={isSelected(opt.value)}
              {...options}
            >
              {opt.label}
            </S.Option>
          ))}
        </AntdOptGroup>
      ));
    }
    if (customOptions) {
      return options;
    }
    return options.map(options => {
      const { value: _value, label: _label } = options;

      return (
        <S.Option key={_value} value={_value} label={_label} {...options}>
          {_label}
        </S.Option>
      );
    });
  };

  const handleSearch = (input, option) => {
    return option.props.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  const decideMode = () => {
    if (addNew) return 'tags';
    if (multi) return 'multiple';
    return;
  };

  return (
    <S.Field
      w={w}
      disabled={disabled}
      open={open}
      focus={focus}
      multi={multi}
      color={decideColor()}
      error={error}
      search={search}
      {...m}
    >
      {label && (
        <CS.Label htmlFor={label}>
          <T.P color={color} m="0" mb="2" weight="700">
            {required && '*'} {label}
          </T.P>
        </CS.Label>
      )}
      <S.Answer>
        <AntdSelect
          value={selected || undefined}
          onChange={(val, option) => handleChange(val, option, name)}
          mode={decideMode()}
          placeholder={placeholder || 'Type here...'}
          showArrow
          filterOption={addNew || handleSearch}
          onDropdownVisibleChange={open => setOpen(open)}
          disabled={disabled}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          ref={selectRef}
          allowClear={allowClear}
          {...props}
        >
          {renderOptions()}
        </AntdSelect>
        {helper && (
          <T.P color={color} mt="2">
            {helper}
          </T.P>
        )}
        {error && (
          <T.P color="error" weight="600" m="0" mt="1">
            {error}
          </T.P>
        )}
      </S.Answer>
    </S.Field>
  );
};

export default Dropdown;
